/**
 * ProjectBadges - Display linked project badges
 * Shows project keys (e.g., "TP", "HR") with tooltips showing full project names
 * Respects dark/light mode theming
 */
import React from 'react';
import './ProjectBadges.css';

const ProjectBadges = ({ projects = [], maxVisible = 3 }) => {
  if (!projects || projects.length === 0) {
    return null;
  }

  const visibleProjects = projects.slice(0, maxVisible);
  const remainingCount = projects.length - maxVisible;

  return (
    <div className="project-badges">
      {visibleProjects.map((project) => (
        <span
          key={project.id}
          className="project-badge"
          title={project.name}
        >
          {project.key}
        </span>
      ))}
      {remainingCount > 0 && (
        <span
          className="project-badge more"
          title={projects.slice(maxVisible).map(p => p.name).join(', ')}
        >
          +{remainingCount}
        </span>
      )}
    </div>
  );
};

export default ProjectBadges;
